import { debounce } from "../utilities/_throttleDebounce"

export default function attachmentsModalController() {
    return {
        isOpen: false,

        // Methods to control the modal
        open() {
						const self = this

            this.isOpen = true;

            // Disable scrolling when modal is open
						//
            document.documentElement.style.overflow = 'hidden';

						// Calulate overlay height
						//
						setTimeout(function() {
								self.calculateOverlayHeight()
						}, 100)
        },

        close() {
            this.isOpen = false;

            // Re-enable scrolling when modal is closed
            document.documentElement.style.overflow = '';
        },

				calculateOverlayHeight() {
						this.$refs.attachmentsModalOverlay.style.height = ''

						if (this.$refs.attachmentsModal.scrollHeight > this.$refs.attachmentsModal.clientHeight) {
								this.$refs.attachmentsModalOverlay.style.height = this.$refs.attachmentsModal.scrollHeight + 'px'
						} else {
								this.$refs.attachmentsModalOverlay.style.height = this.$refs.attachmentsModal.clientHeight + 'px'
						}
				},

        init() {
						const self = this

            // Listen for "Attachments" button clicks
						//
            this.$watch('$store.attachmentsModal.requestOpen', (value) => {
                if (value) {
                    this.open();
                    // Reset the flag
                    this.$store.attachmentsModal.requestOpen = false;
                }
            });

						// Handle modal overlay
						//
						window.addEventListener('resize', debounce(function() {
								self.calculateOverlayHeight()
						}, 100))
        }
    };
}
